/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Shadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 563px;
  z-index: -1;
  background: linear-gradient(180deg, ${t.color.lightGrey}, ${t.color.white});
  
  ${t.mixins.sm(`
    height: 350px;
  `)}
`;

/**
 * background component is.. 
 */

const Shadow__background = ({ style }) => <Shadow style={style} />;

export default Shadow__background;

Shadow__background.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Shadow__background.defaultProps = {
  style: {},
};

/*
    import Shadow__background from 'components/shadow/background/shadow__background'
    <Shadow__background />
  */
